import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import Spline from '../spline.js';
import Utils from '../utils.js';
import GeoUtils from '../geoUtils.js';

export default class NodeCopyAlongPathV2 extends Node
{
	static RESAMPLE_CHOICES =
	[
		{key: 'byDistance', label: 'By Distance'},
		{key: 'byNumPoints', label: 'By Number of Points'},
	]


	static COPY_TYPES =
	[
		{key: 'vertsOnly', label: 'Copy to Vertices Only'},
		{key: 'resample', label: 'Copy Along Resampled Path'},
	]

	static CORNER_BEH_TYPES =
	[
		{key: 'ignore', label: 'Ignore sharp corners'},
		{key: 'skipsharp', label: 'Copy to all points except sharp corners'},
		{key: 'onlysharp', label: 'Copy to sharp corners only'},
	]

	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.GEOMETRY, 'object', null);
		this.addInput(PARAM_TYPE.SPLINE, 'path', null);

		this.addInput(PARAM_TYPE.DROPDOWN, 'copy_type', NodeCopyAlongPathV2.COPY_TYPES[1].key, { dropdownOptions: NodeCopyAlongPathV2.COPY_TYPES });

		this.addInput(PARAM_TYPE.STRING, 'copy_pattern', '1,0');
		this.addInput(PARAM_TYPE.BOOLEAN, 'reset_pattern_after_corners', false);
		this.addInput(PARAM_TYPE.BOOLEAN, 'invert_pattern', false);
		this.addInput(PARAM_TYPE.BOOLEAN, 'orient_with_path', true);

		this.addInput(PARAM_TYPE.DROPDOWN, 'corner_behavior', NodeCopyAlongPathV2.CORNER_BEH_TYPES[0].key, { dropdownOptions: NodeCopyAlongPathV2.CORNER_BEH_TYPES });
		this.addInput(PARAM_TYPE.FLOAT, 'corner_angle', 90.0, { minValue: 0, maxValue: 180, units: PARAM_UNITS.DEGREES });

		this.addInput(PARAM_TYPE.FLOAT, 'perp_offset', 0.0, { minValue: -3, maxValue: 3, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.BOOLEAN, 'use_instances', false);

		this.addInputsToGroup('Copying', ['copy_pattern', 'reset_pattern_after_corners', 'invert_pattern', 'orient_with_path', 'corner_behavior', 'corner_angle', 'perp_offset']);


		this.addInput(PARAM_TYPE.DROPDOWN, 'resample_type', NodeCopyAlongPathV2.RESAMPLE_CHOICES[0].key, { dropdownOptions: NodeCopyAlongPathV2.RESAMPLE_CHOICES });

		this.addInput(PARAM_TYPE.FLOAT, 'spacing', 0.1, { minValue: 0.001, maxValue: 0.5, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.INTEGER, 'num_points', 6, { minValue: 1, maxValue: 50 });

		this.addInput(PARAM_TYPE.BOOLEAN, 'preserve_corners', false);
		this.addInput(PARAM_TYPE.FLOAT, 'preserve_angle', 90.0, { minValue: 0, maxValue: 180, units: PARAM_UNITS.DEGREES });

		this.addInput(PARAM_TYPE.FLOAT, 'start', 0.0, { minValue: 0, maxValue: 100, units: PARAM_UNITS.PERCENT });
		this.addInput(PARAM_TYPE.FLOAT, 'end', 100.0, { minValue: 0, maxValue: 100, units: PARAM_UNITS.PERCENT });

		this.addInput(PARAM_TYPE.BOOLEAN, 'extend_last_point', false);

		this.addInputsToGroup('Resampling', ['copy_type', 'resample_type', 'spacing', 'num_points', 'preserve_corners', 'preserve_angle', 'start', 'end', 'extend_last_point']);

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}

	getType()
	{
		return 'copyAlongPath_v2';
	}

	getIsInputEnabledSubclass(strInputName)
	{
		const copyType = this.getLastInputResult('copy_type');
		const resampleType = this.getLastInputResult('resample_type');

		if(strInputName === 'spacing' || strInputName === 'extend_last_point')
			return resampleType == NodeCopyAlongPathV2.RESAMPLE_CHOICES[0].key && copyType == 'resample';
		else if(strInputName === 'num_points')
			return resampleType == NodeCopyAlongPathV2.RESAMPLE_CHOICES[1].key && copyType == 'resample';
		else if(strInputName === 'resample_type' || strInputName === 'preserve_corners' || strInputName === 'preserve_angle')
			return copyType == 'resample';

		return true;
	}

	getRefreshEnableStatusAfterParamChange(strInputName)
	{
		return strInputName == 'resample_type' || strInputName == 'copy_type';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		let pCopyObjects = inputValues['object'];
		if(!pCopyObjects || pCopyObjects.length === 0)
			return null;

		if(!Array.isArray(pCopyObjects))
			pCopyObjects = [pCopyObjects];

		pCopyObjects = pCopyObjects.filter((obj) => { return Utils.getIsMeshObject(obj); });
		if(pCopyObjects.length === 0)
			return null;

		let listPath = inputValues['path'];
		if(!listPath || listPath.points.length < 1)
			return null;

		let pPathSpline = new Spline(listPath);
		pPathSpline.ensureOrientation();

		let iCounter = 0;
		let pFinalMeshes = GeoUtils.copyObjectsAlongSpline(pCopyObjects, pPathSpline, inputValues,
			(pMesh) => {
				pMesh.name = `${this.getGeneratedMeshName()}_${iCounter}`;
				iCounter++;
				this.onMeshCreated(pMesh);
			});

		for(let pMesh of pCopyObjects)
			pMesh.dispose();

		return pFinalMeshes;
	}

}